module.exports = __webpack_public_path__ + "static/media/Heartsick_Bookcover.a6640957.jpg";